import { UserVSOrganizationInsert, UserVSOrganizationInsertMany, UserVSOrganizationDelete, UserVSOrganizationUpdate, UserVSOrganizationGetById, UserVSOrganizationGetList, UserVSOrganizationGetPageList } from "@/api/uservsorganization/index.js";

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
    // 新增
    UserVSOrganizationInsert(context, payload) {
        return new Promise((resolve, reject) => {
            UserVSOrganizationInsert({ ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 新增
    UserVSOrganizationInsertMany(context, payload) {
        return new Promise((resolve, reject) => {
            UserVSOrganizationInsertMany(payload).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 更新
    UserVSOrganizationUpdate(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            UserVSOrganizationUpdate(id, { ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取
    UserVSOrganizationGetById(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            UserVSOrganizationGetById(id).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取列表
    UserVSOrganizationGetList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            UserVSOrganizationGetList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取分页列表
    UserVSOrganizationGetPageList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            UserVSOrganizationGetPageList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}